import React from 'react';
import { Container, styled } from '@mui/material';

const Section = ({ children, ...rest }) => (
  <StyledSection maxWidth='lg' {...rest}>
    {children}
  </StyledSection>
);

export default Section;

const StyledSection = styled(Container)(({ theme }) => ({
  padding: theme.spacing(15, 0),
  minHeight: '70vh',

  [theme.breakpoints.down('lg')]: {
    maxWidth: '90vw',
  },
}));
